// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { getIqAssessment, UpdateUser } from "../api/api";
// import "../IQAssessment/IQAssessment.css";
// import bgImage from "../../assets/images/brown-background.jpg";
// import RegistraionFlowHeader from "../RegistraionFlowHeader/RegistraionFlowHeader";

// const IQAssessment = () => {
//   const navigate = useNavigate();
//   const [selectedAnswers, setSelectedAnswers] = useState({});
//   const [questions, setQuestions] = useState([]);
//   const [currentPage, setCurrentPage] = useState(0);
//   const questionsPerPage = 1;
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     const fetchTemperamentAssessment = async () => {
//       try {
//         const response = await getIqAssessment();
//         console.log("API Response getIqAssessment:", JSON.stringify(response));
//         if (response?.success) {
//           // ✅ Fix: Map `answers` to `options`
//           const formattedQuestions = response.data.map((item, index) => ({
//             id: item.id, // Ensure ID is unique
//             question: item.question,
//             options: item.answers.map((answer, idx) => ({
//               index: answer.index || idx, // Ensure index is unique
//               answer: answer.answer,
//               category_id: answer.category_id || answer.category,
//             })),
//           }));
//           console.log("Formatted Questions:", formattedQuestions);
//           setQuestions(formattedQuestions);
//         } else {
//           alert("Failed to fetch Temperament Assessment Questions");
//         }
//       } catch (error) {
//         console.error("Error fetching questions:", error);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchTemperamentAssessment();
//   }, []);

//   const handleOptionPress = (questionId, optionIndex) => {
//     setSelectedAnswers((prev) => ({
//       ...prev,
//       [questionId]: prev[questionId] === optionIndex ? null : optionIndex,
//     }));
//   };

//   const handleSubmit = async () => {
//     const unansweredQuestions = questions.filter((q) => !selectedAnswers[q.id]);

//     if (unansweredQuestions.length > 0) {
//       alert("Please answer all questions");
//     } else {
//       try {
//         const userData = JSON.parse(localStorage.getItem("currentUser"));
//         const userId = userData?.id || userData?._id;

//         const formattedAnswers = Object.entries(selectedAnswers).map(
//           ([questionId, selectedOptionIndex]) => {
//             return {
//               question_id: questionId,
//               option_index: String(selectedOptionIndex),
//             };
//           }
//         );

//         const values = {
//           user_id: userId,
//           userAnswersIQ: formattedAnswers,
//           notify_admin_for_signup: "1",
//           profile_completion_status: "FinalSubmissionPage",
//         };
//         console.log("valuepass", values);
//         const response = await UpdateUser(values);

//         if (response?.success) {
//           navigate("/FinalSubmissionPage");
//         } else {
//           alert(response.message || "Submission failed");
//         }
//       } catch (error) {
//         console.error("Error submitting assessment:", error);
//       }
//     }
//   };

//   const startIndex = currentPage * questionsPerPage;
//   const currentQuestions = (questions || []).slice(
//     startIndex,
//     startIndex + questionsPerPage
//   );

//   // ✅ Fix: Only check `isNextEnabled` if `currentQuestions` is not empty
//   const isNextEnabled =
//     currentQuestions?.length > 0 && !!selectedAnswers[currentQuestions[0]?.id];

//   if (isLoading) {
//     return <div>Loading questions...</div>;
//   }
//   const unansweredQuestions = questions?.filter((q) => !selectedAnswers[q.id]);

//   return (
//     <div
//       className="IQcontainer sechdr-toppding"
//       style={{
//         backgroundImage: `url(${bgImage})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         backgroundRepeat: "no-repeat",
//       }}
//     >
//       <div className="containerall">
//         <RegistraionFlowHeader />
//         <div className="IQSmallContainer">
//           <h1 className="IQtitle">IQ Assessment</h1>
//           {currentQuestions?.map((question, index) => (
//             <div key={question?.id} className="question-container">
//               <p className="question-text">{`Q${startIndex + index + 1}: ${question?.question
//                 }`}</p>

//               {question.options.map((option, idx) => (
//                 <div
//                   key={option.index}
//                   className={`option-container ${selectedAnswers[question.id] === option.index
//                     ? "selected-option"
//                     : ""
//                     }`}
//                   onClick={() => handleOptionPress(question.id, option.index)}
//                 >
//                   <div
//                     className={`radio-button ${selectedAnswers[question.id] === option.index
//                       ? "selected-radio-button"
//                       : ""
//                       }`}
//                   />
//                   <p className="option-text">{option.answer}</p>
//                 </div>
//               ))}
//             </div>
//           ))}

//           <div className="navigation-container">
//             {/* ✅ Fix: Show "Previous" only if not on the first question */}
//             {currentPage > 0 && (
//               <button
//                 className="previous-button"
//                 onClick={() => setCurrentPage((prev) => prev - 1)}
//               >
//                 Previous
//               </button>
//             )}

//             {/* ✅ Fix: Enable "Next" only if an option is selected */}
//             {currentPage < Math.ceil(questions.length / questionsPerPage) - 1 ? (
//               <button
//                 className={`navigation-button ${!isNextEnabled ? "disabled-button" : ""
//                   }`}
//                 onClick={() => setCurrentPage((prev) => prev + 1)}
//                 disabled={!isNextEnabled}
//               >
//                 Next
//               </button>
//             ) : (
//               <button
//                 className="IQsubmit-button"
//                 onClick={handleSubmit}
//                 disabled={unansweredQuestions?.length > 0}
//               >
//                 Submit
//               </button>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default IQAssessment;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getIqAssessment, UpdateUser } from "../api/api";
import "../IQAssessment/IQAssessment.css";
import bgImage from "../../assets/images/brown-background.jpg";
import RegistraionFlowHeader from "../RegistraionFlowHeader/RegistraionFlowHeader";

const IQAssessment = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [questions, setQuestions] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const questionsPerPage = 1;
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchTemperamentAssessment = async () => {
      try {
        const response = await getIqAssessment();
        console.log("API Response getIqAssessment:", JSON.stringify(response));
        if (response?.success) {
          const formattedQuestions = response.data.map((item) => ({
            id: String(item.id),
            question: item.question,
            options: item.answers.map((answer) => ({
              id: String(answer.id),
              answer: answer.answer,
            })),
          }));

          console.log("Formatted Questions:", formattedQuestions);
          setQuestions(formattedQuestions);
        } else {
          alert("Failed to fetch Temperament Assessment Questions");
        }
      } catch (error) {
        console.error("Error fetching questions:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTemperamentAssessment();
  }, []);

  const handleOptionPress = (questionId, optionId) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionId]: optionId,
    }));
  };

  const handleSubmit = async () => {
    const unansweredQuestions = questions.filter((q) => !selectedAnswers[q.id]);

    if (unansweredQuestions.length > 0) {
      alert("Please answer all questions");
    } else {
      try {
        const userData = JSON.parse(localStorage.getItem("currentUser"));
        const userId = userData?.id || userData?._id;

        const formattedAnswers = Object.entries(selectedAnswers).map(
          ([questionId, optionId]) => ({
            question_id: questionId,
            option_index: optionId,
          })
        );

        const values = {
          user_id: userId,
          userAnswersIQ: formattedAnswers,
          notify_admin_for_signup: "1",
          profile_completion_status: "FinalSubmissionPage",
        };
        console.log("valuepass", values);
        const response = await UpdateUser(values);

        if (response?.success) {
          navigate("/FinalSubmissionPage");
        } else {
          alert(response.message || "Submission failed");
        }
      } catch (error) {
        console.error("Error submitting assessment:", error);
      }
    }
  };

  const startIndex = currentPage * questionsPerPage;
  const currentQuestions = (questions || []).slice(
    startIndex,
    startIndex + questionsPerPage
  );

  // ✅ Fix: Only check `isNextEnabled` if `currentQuestions` is not empty
  const isNextEnabled =
    currentQuestions?.length > 0 && !!selectedAnswers[currentQuestions[0]?.id];

  if (isLoading) {
    return <div>Loading questions...</div>;
  }
  const unansweredQuestions = questions?.filter((q) => !selectedAnswers[q.id]);

  return (
    <div
      className="IQcontainer sechdr-toppding"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="containerall">
        <RegistraionFlowHeader />
        <div className="IQSmallContainer">
          <h1 className="IQtitle">IQ Assessment</h1>
          {currentQuestions?.map((question, index) => (
            <div key={question?.id} className="question-container">
              <p className="question-text">{`Q${startIndex + index + 1}: ${
                question?.question
              }`}</p>

              {question.options.map((option) => (
                <div
                  key={option.id}
                  className={`option-container ${
                    selectedAnswers[question.id] === option.id
                      ? "selected-option"
                      : ""
                  }`}
                  onClick={() => handleOptionPress(question.id, option.id)}
                >
                  <div
                    className={`radio-button ${
                      selectedAnswers[question.id] === option.id
                        ? "selected-radio-button"
                        : ""
                    }`}
                  />
                  <p className="option-text">{option.answer}</p>
                </div>
              ))}
            </div>
          ))}

          <div className="navigation-container">
            {/* ✅ Fix: Show "Previous" only if not on the first question */}
            {currentPage > 0 && (
              <button
                className="previous-button"
                onClick={() => setCurrentPage((prev) => prev - 1)}
              >
                Previous
              </button>
            )}

            {/* ✅ Fix: Enable "Next" only if an option is selected */}
            {currentPage <
            Math.ceil(questions.length / questionsPerPage) - 1 ? (
              <button
                className={`navigation-button ${
                  !isNextEnabled ? "disabled-button" : ""
                }`}
                onClick={() => setCurrentPage((prev) => prev + 1)}
                disabled={!isNextEnabled}
              >
                Next
              </button>
            ) : (
              <button
                className="IQsubmit-button"
                onClick={handleSubmit}
                disabled={unansweredQuestions?.length > 0}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IQAssessment;
